<template>
  <div>
    <v-row justify="center">
      <v-dialog max-width="900px" persistent v-model="dialogForm">
        <v-card>
          <v-toolbar color="grey lighten-4" flat>
            <v-toolbar-title class="text-h6">{{ formTitle }}</v-toolbar-title>
            <v-spacer />
          </v-toolbar>
          <v-form @submit.prevent="submit" lazy-validation ref="form" v-model="valid">
            <v-overlay absolute :value="loading" opacity="0.7">
              <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
            <v-card-text class="pb-0">
              <v-container fluid>
                <v-row>
                  <v-col class="py-0" cols="12">
                    <v-autocomplete
                      :error-messages="errors.veiculo_id"
                      :items="veiculos"
                      :loading="isloadingVeiculo"
                      :rules="rules.veiculo_id"
                      :search-input.sync="searchAutoCompleteVeiculo"
                      clearable
                      dense
                      hide-no-data
                      hide-selected
                      item-text="nome"
                      item-value="id"
                      label="Veículos"
                      outlined
                      placeholder="Selecione um veículo"
                      v-model="formData.veiculo_id"
                    >
                      <template v-slot:selection="data">
                        {{ data.item.modelo.marca.nome }} - {{ data.item.modelo.nome }}
                      </template>

                      <template v-slot:item="data">
                        <v-list-item-content>
                          <v-list-item-title>
                            {{ data.item.modelo.marca.nome }} - {{ data.item.modelo.nome }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </template>

                      <template v-slot:append-outer>
                        <v-btn color="teal" dark depressed tile>
                          <v-icon left>mdi-plus</v-icon>
                          Adicionar
                        </v-btn>
                      </template>
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="py-0" md="2" cols="6">
                    <v-text-field
                      :error-messages="errors.valor"
                      :rules="rules.valor"
                      class="pa-0"
                      dense
                      label="Valor *"
                      outlined
                      v-model="formData.valor"
                    ></v-text-field>
                  </v-col>
                  <v-col class="py-0" md="2" cols="6">
                    <v-text-field
                      :error-messages="errors.km_inicial"
                      :rules="rules.km_inicial"
                      class="pa-0"
                      dense
                      label="Km Inicial"
                      outlined
                      type="number"
                      v-model="formData.km_inicial"
                    ></v-text-field>
                  </v-col>
                  <v-col class="py-0" md="4" cols="6">
                    <v-autocomplete
                      :error-messages="errors.contrato_veiculo_situacao_id"
                      :items="situacoes"
                      :loading="isloadingContratoVeiculoSituacao"
                      :rules="rules.contrato_veiculo_situacao_id"
                      :search-input.sync="searchAutoCompleteContratoVeiculoSituacao"
                      clearable
                      dense
                      hide-no-data
                      hide-selected
                      item-text="nome"
                      item-value="id"
                      label="Situações"
                      outlined
                      placeholder="Selecione uma situação"
                      v-model="formData.contrato_veiculo_situacao_id"
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col class="py-0" md="4" cols="6">
                    <v-autocomplete
                      :error-messages="errors.orgao_origem_id"
                      :items="orgaos"
                      :loading="isloadingOrgaos"
                      :rules="rules.orgao_origem_id"
                      :search-input.sync="searchAutoCompleteOrgao"
                      clearable
                      dense
                      hide-no-data
                      hide-selected
                      item-text="nome"
                      item-value="id"
                      label="Orgãos"
                      outlined
                      placeholder="Selecione um orgão"
                      v-model="formData.orgao_origem_id"
                    >
                    </v-autocomplete>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions class="pa-4">
              <v-spacer></v-spacer>
              <v-btn @click="toggleForm" color="red" dark depressed>
                <v-icon left small>mdi-close</v-icon>
                Fechar
              </v-btn>
              <v-btn
                :disabled="!valid"
                :loading="loadingSubmit"
                color="green"
                dark
                depressed
                type="submit"
              >
                <v-icon left small>mdi-send</v-icon>
                Salvar
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { required } from '@/services/util/validate';
import toastMessage from '@/services/util/alertService';
import orgaoHttp from '@/services/http/resources/configuracao/orgaoHttp';
import veiculoContratoHttp from '@/services/http/resources/frota/veiculoContratoHttp';
import contratoVeiculoSituacaoHttp from '@/services/http/resources/frota/contratoVeiculoSituacaoHttp';

export default {
  name: 'VeiculoContratoModalForm',
  data: () => ({
    valid: true,
    veiculos: [],
    situacoes: [],
    orgaos: [],
    formData: {
      id: '',
      valor: '',
      km_inicial: '',
      contrato_id: '',
      veiculo_id: '',
      contrato_veiculo_situacao_id: '',
      orgao_origem_id: '',
    },
    formDataDefault: {
      id: '',
      valor: '',
      km_inicial: '',
      contrato_id: '',
      veiculo_id: '',
      contrato_veiculo_situacao_id: '',
      orgao_origem_id: '',
    },
    rules: {
      valor: [required],
      veiculo_id: [required],
      contrato_veiculo_situacao_id: [required],
      orgao_origem_id: [required],
    },
    errors: {
      valor: [],
      veiculo_id: [],
      contrato_veiculo_situacao_id: [],
      orgao_origem_id: [],
    },
    loading: false,
    loadingSubmit: false,
    isloadingOrgaos: false,
    isloadingVeiculo: false,
    isloadingContratoVeiculoSituacao: false,
    searchAutoCompleteOrgao: '',
    searchAutoCompleteVeiculo: '',
    searchAutoCompleteContratoVeiculoSituacao: '',
  }),
  computed: {
    ...mapState('contrato', { dataContrato: 'data' }),
    ...mapState('contratoVeiculo', ['dataIndex', 'data', 'dialogForm']),
    formTitle() {
      return this.dataIndex === -1 ? 'Adicionar Veículo' : 'Editar Veículo';
    },
  },
  methods: {
    ...mapActions('contratoVeiculo', [
      'toggleForm',
      'store',
      'update',
      'setDataIndex',
      'clearData',
    ]),
    resetValidation() {
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    submit() {
      if (this.$refs.form.validate()) {
        this.loadingSubmit = true;
        this.formData.contrato_id = this.dataContrato.id;
        const actionHttp = this.dataIndex === -1
          ? this.store(this.formData)
          : this.update(this.formData);
        actionHttp
          .then(() => {
            toastMessage.successSave('Veículo salvo com sucesso');
            this.$refs.form.reset();
          })
          .catch(({ response }) => {
            if (response.status === 422) {
              const { errors } = response.data;
              Object.entries(errors).forEach(([index, value]) => {
                this.errors[index].push(value.toString());
                toastMessage.errorValidation();
              });
            } else {
              toastMessage.errorSave();
            }
          })
          .then(() => {
            this.loadingSubmit = false;
          });
      }
    },
    openDialog() {
      this.resetValidation();
      this.resetAutoComplete();
      this.loadAll().then(() => {
        if (this.dataIndex > -1) {
          Object.entries(this.formDataDefault).forEach(([key]) => {
            if (key === 'contrato_id') {
              this.formData[key] = this.dataContrato.id;
            } else if (key === 'veiculo_id') {
              this.veiculos.push(this.data.veiculo);
              this.formData[key] = this.data[key];
            } else {
              this.formData[key] = this.data[key];
            }
          });
        }
      });
    },
    closeDialog() {
      setTimeout(() => {
        Object.entries(this.formDataDefault).forEach(([key]) => {
          this.formData[key] = this.formDataDefault[key];
        });
        this.resetAutoComplete();
        this.resetValidation();
        this.clearData();
        this.setDataIndex(-1);
      }, 300);
    },
    async loadAll() {
      this.loading = true;
      await Promise.all([
        this.loadVeiculos(),
        this.loadOrgaos(),
        this.loadSituacoes(),
      ]).catch(() => {
        toastMessage.errorLoading('Erro ao carregar dados.');
      }).finally(() => {
        this.loading = false;
      });
    },
    async loadOrgaos() {
      this.isloadingOrgaos = true;
      await orgaoHttp
        .list()
        .then(({ data: { data } }) => {
          this.orgaos = data;
        })
        .catch(() => toastMessage.errorLoading('Erro ao carregar Orgãos'))
        .finally(() => {
          this.isloadingOrgaos = false;
        });
    },
    async loadSituacoes() {
      this.isloadingContratoVeiculoSituacao = true;
      await contratoVeiculoSituacaoHttp
        .list()
        .then(({ data: { data } }) => {
          this.situacoes = data;
        })
        .catch(() => toastMessage.errorLoading('Erro ao carregar Situações'))
        .finally(() => {
          this.isloadingContratoVeiculoSituacao = false;
        });
    },
    async loadVeiculos() {
      this.isloadingVeiculo = true;
      await veiculoContratoHttp
        .list()
        .then(({ data: { data } }) => {
          this.veiculos = data;
        })
        .catch(() => toastMessage.errorLoading('Erro ao carregar Veículos'))
        .finally(() => {
          this.isloadingVeiculo = false;
        });
    },
    resetAutoComplete() {
      this.orgaos = [];
      this.veiculos = [];
      this.situacoes = [];
      this.searchAutoCompleteOrgao = null;
      this.searchAutoCompleteVeiculo = null;
      this.searchAutoCompleteContratoVeiculoSituacao = null;
    },
  },
  watch: {
    dialogForm(value) {
      if (value) {
        this.openDialog();
      } else {
        this.closeDialog();
      }
    },
    'dados.nome': function () {
      this.errors.nome = [];
    },
    'dados.ordem': function () {
      this.errors.ordem = [];
    },
  },
};
</script>
